module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vw >= 640),
      expression: "vw >=640"
    }],
    staticClass: "gridM"
  }, [_c('ul', {
    staticClass: "grid"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('div', {
      staticClass: "item"
    }, [_c('a', {
      staticClass: "imgContainer",
      style: (("background-image: url(\"" + (item.img) + "\")")),
      attrs: {
        "href": item.link
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "articleText"
    }, [_vm._l((item.title), function(ttl) {
      return _c('a', {
        staticClass: "title",
        attrs: {
          "href": ttl.linkArticle
        }
      }, [_vm._v(_vm._s(ttl.article))])
    }), _vm._v(" "), _c('a', {
      staticClass: "description",
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('div', {
      staticClass: "bottomInfo"
    }, [_c('p', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))]), _vm._v(" "), _c('p', {
      staticClass: "see"
    }, [_vm._v(_vm._s(item.see) + "\n\t\t\t\t\t\t\t\t"), _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "feed"
    }, [_vm._v(_vm._s(item.feed) + "\n\t\t\t\t\t\t\t\t"), _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0V0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
      }
    })])])])], 2)])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vw < 640),
      expression: "vw <640"
    }],
    staticClass: "sliderS"
  }, [_c('div', {
    staticClass: "owl-carousel"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('div', {
      staticClass: "item"
    }, [_c('a', {
      staticClass: "imgContainer",
      style: (("background-image: url(\"" + (item.img) + "\")")),
      attrs: {
        "href": item.link
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "articleText"
    }, [_vm._l((item.title), function(ttl) {
      return _c('a', {
        staticClass: "title",
        attrs: {
          "href": item.linkArticle
        }
      }, [_vm._v(_vm._s(ttl.article))])
    }), _vm._v(" "), _c('a', {
      staticClass: "description",
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('div', {
      staticClass: "bottomInfo"
    }, [_c('p', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data))]), _vm._v(" "), _c('p', {
      staticClass: "see"
    }, [_vm._v(_vm._s(item.see) + "\n\t\t\t\t\t\t\t\t"), _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "feed"
    }, [_vm._v(_vm._s(item.feed) + "\n\t\t\t\t\t\t\t\t"), _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0V0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
      }
    })])])])], 2)])]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-036be3b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/smallSlider.vue
// module id = 372
// module chunks = 14